import axios from "axios";
import { getAuthHeader } from "../../utils/authHeader";
import {
    CaptionRenderAudit,
    CaptionViolationMetrics,
    PaginatedCaptionViolations,
    SlideFailureReason,
} from "./types";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/admin/caption-violations`;

export interface GetCaptionViolationsParams {
    page?: number;
    limit?: number;
    reason?: SlideFailureReason;
    days?: number;
}

export async function getCaptionViolations({
    page = 1,
    limit = 20,
    reason,
    days = 30,
}: GetCaptionViolationsParams = {}): Promise<PaginatedCaptionViolations> {
    try {
        const headers = await getAuthHeader();
        const params: Record<string, string | number> = { page, limit, days };
        if (reason) params.reason = reason;

        const response = await axios.get<PaginatedCaptionViolations>(BASE_URL, {
            params,
            headers,
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching caption violations:", error);
        throw new Error("Error fetching caption violations");
    }
}

export async function getCaptionViolationMetrics(
    days = 30
): Promise<CaptionViolationMetrics> {
    try {
        const headers = await getAuthHeader();
        const response = await axios.get<CaptionViolationMetrics>(
            `${BASE_URL}/metrics`,
            { params: { days }, headers }
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching caption violation metrics:", error);
        throw new Error("Error fetching caption violation metrics");
    }
}

/**
 * The full audit artifact for ONE render. Called only when a reviewer opens it — the
 * payload carries the listing text and every raw model response, so it is not something
 * to fetch for 20 rows that nobody has asked to see.
 */
export async function getCaptionRenderAudit(
    captionRenderId: string
): Promise<CaptionRenderAudit> {
    try {
        const headers = await getAuthHeader();
        const response = await axios.get<CaptionRenderAudit>(
            `${BASE_URL}/audit/${captionRenderId}`,
            { headers }
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching caption render audit:", error);
        throw new Error("Error fetching caption render audit");
    }
}
